// Renders the homepage "Hot Now" teaser from the backend's ranked feed
// (this month's top-3 best-sellers + 2 most-recently-created puzzles,
// interleaved — see src/db.js's getHotNowProductIds). The section renders
// with skeleton placeholder cards already in place (reserving its real
// height so later sections don't shift once data lands) and those
// skeletons are replaced by real cards on success, or the whole section is
// hidden on error/empty — matching how the old native-collection version
// only rendered its wrapper when the collection had products.
(() => {
  const section = document.querySelector("[data-hot-now-section]");
  if (!section) return;
  const grid = section.querySelector("[data-hot-now-grid]");
  const backendUrl = window.PieceworkBackendUrl;
  const productStrings = (window.PieceworkStrings && window.PieceworkStrings.product) || {};

  // textContent/innerHTML round-tripping only encodes &/</> — leaves quotes
  // alone, which is unsafe wherever the result lands inside a double-quoted
  // HTML attribute (e.g. alt="${escapeHtml(...)}"), not just a text node.
  function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (ch) => (
      { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]
    ));
  }

  function money(amount) {
    return `$${Number(amount).toFixed(2)}`;
  }

  function renderCard(product, index) {
    const gradientIndex = index % 5;
    const card = document.createElement("div");
    card.className = "product-card product-card--vivid";

    const image = product.imageUrl
      ? `<img src="${escapeHtml(product.imageUrl)}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="600">`
      : "";

    const addToCartButton = product.available
      ? `<button type="button" class="btn btn-secondary product-card__add-to-cart"
          data-piecework-add-product
          data-variant-id="${escapeHtml(product.variantId)}"
          data-title="${escapeHtml(product.title)}"
          data-price="${escapeHtml(product.price)}"
          data-image="${escapeHtml(product.imageUrl)}"
          data-url="${escapeHtml(product.url)}"
          data-pieces="${escapeHtml(product.sizeLabel ? product.sizeLabel.replace(" piece", "") : "")}"
        >${escapeHtml(productStrings.addToCart || "Add to cart")}</button>`
      : "";

    const fireBadge = product.isTopSeller
      ? `<span class="product-card__fire-badge" aria-hidden="true">🔥</span>`
      : "";

    card.innerHTML = `
      ${fireBadge}
      <a href="${escapeHtml(product.url)}">
        <div class="product-card__image product-card__image--vivid gradient-${gradientIndex}">${image}</div>
        <div class="product-card__title">${escapeHtml(product.title)}</div>
        <div class="product-card__price">${money(product.price)}</div>
      </a>
      ${addToCartButton}
    `;
    return card;
  }

  async function init() {
    if (!backendUrl) {
      section.hidden = true;
      return;
    }
    try {
      const response = await fetch(`${backendUrl}/api/hot-now`);
      if (!response.ok) {
        section.hidden = true;
        return;
      }
      const { products } = await response.json();
      if (!products || products.length === 0) {
        section.hidden = true;
        return;
      }

      grid.querySelectorAll("[data-hot-now-skeleton]").forEach((el) => el.remove());
      products.forEach((product, index) => grid.appendChild(renderCard(product, index)));
    } catch (err) {
      console.error("Hot Now: couldn't load products.", err);
      section.hidden = true;
    }
  }

  init();
})();
